export const countNumberSummaryItems = (items, data) => {
	return items.map(item => ({
		...item,
		count: data[item.title] ?? 0,
	}));
};
